/**
 *  @docsCategory preference/lang
 */
const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

/**
 * @description
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 * - typeof window -> undefined
 * - typeof document -> undefined
 *
 * react-native:
 * - navigator.product -> 'ReactNative'
 *
 * nativescript
 * - navigator.product -> 'NativeScript' or 'NS'
 *
 * @docsCategory preference/lang
 * @codeFilter is-standard-browser-env
 */
export function isStandardBrowserEnv() {
  if (
    typeof navigator !== 'undefined' &&
    (navigator.product === 'ReactNative' ||
      navigator.product === 'NativeScript' ||
      navigator.product === 'NS')
  ) {
    return false;
  }
  return canUseDOM;
}
